import { useQuery } from '@tanstack/react-query';

import { fetchActionRequiredCount } from '../services';

type UseActionRequiredCountOptions = {
  enabled?: boolean;
  grouped?: boolean;
};

/**
 * Count of notifications still waiting on the user. Read state plays no part:
 * reading an approval does not answer it, so this only drops when the action
 * itself is completed.
 *
 * `enabled` exists for the feature-flagged callers: the query polls every
 * minute, so a surface that will not show the count should not ask for it.
 */
export function useActionRequiredCount({
  enabled = true,
  grouped = false,
}: UseActionRequiredCountOptions = {}) {
  return useQuery({
    queryKey: ['notifications', 'action-required-count', grouped],
    queryFn: async () => {
      const data = await fetchActionRequiredCount(grouped);
      return data.count;
    },
    enabled,
    refetchInterval: 60_000,
  });
}
